import {
    getQuestionList
} from "@/api/question";
const state = {
    rwshBtnPermission: true,
    questionList: {
        params: {
            type: "0",
            sun: "",
            name: "",
            bmbh: "",
            txlx: "",
            status: "",
            rlr: null,
            title: "",
            rlrq: "",
            page: 1,
            pageSize: 10,
        },
        list: {
            item: [],
            count: 0,
            listLoading: true
        }
    },

};
const mutations = {

    saveRwshBtnPermission(state, payload) {
        state.rwshBtnPermission = payload.flag;
    },
    fetchQuestionList(state, payload) {
        if (payload.res.code == 0) {
            state.questionList.params = payload.params;
            state.questionList.list.item = payload.res.data;
            state.questionList.list.count = payload.res.count;
            state.questionList.list.listLoading = false;
            for (let i in payload.res.data) {
                if (!payload.res.data[i].solvePlan) {
                    payload.res.data[i].solvePlan = payload.res.data[i].progress + '%';
                }
            }
        }
    },
};
const actions = {

    setRwshBtnPermission(context, payload) {
        context.commit('saveRwshBtnPermission', payload);
    },
    fetchQuestionListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getQuestionList(payload)
                .then((res) => {
                    context.commit("fetchQuestionList", { res, params: payload });
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
